import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Message } from 'primeng/primeng';

type Severities = 'success' | 'info' | 'warn' | 'error';

@Injectable()
export class NotificationsService {
  growlNotificationChange: Subject<Object> = new Subject<Object>();
  messageNotificationChange: Subject<Object> = new Subject<Object>();

  private message: Message[] = [];

  messageNotifyNow() {
    this.messageNotificationChange.next(this.message);
    this.message = [];
  }

  growlNotify(severity: Severities, summary: string, detail?: string, key?: string) {
    this.growlNotificationChange.next({ severity, summary, detail, key });
  }

  messageNotify(severity: Severities, summary: string, detail?: string, key?: string) {
    this.messageNotificationChange.next({ severity, summary, detail, key });
  }

  addNotification(severity: Severities, summary: string, detail?: string, key?: string) {
    this.message.push({ severity, summary, detail });
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/services/notifications/notifications.service.ts